<template>
    <div class="fs5-disclosure">
        <div class="fs5-disclosure-card" >
            <div class="fs5-disclosure-card-header">
                <span class="fs5-disclosure-card-header-title" v-html="view.header.title" ></span>
                <div class="fs5-tooltip-icon">
                    <svg
                        v-if="view.header.showTooltip"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                        class="icon"
                        data-toggle="tooltip"
                        rel="tooltip"
                        data-placement="bottom"
                        data-html="true"
                        :data-title="view.header.tooltip"
                    >
                        <path d="M8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16ZM8 1.16C4.228 1.16 1.159 4.2275 1.159 8C1.159 11.7715 4.228 14.84 8 14.84C11.772 14.84 14.841 11.7715 14.841 8C14.841 4.2275 11.772 1.16 8 1.16Z" fill="#0080FC"/>
                        <path d="M8.16495 12.1515C8.10345 12.128 8.03694 12.09 8.03694 11.929C8.03694 11.8625 8.04745 11.7855 8.07094 11.6915L9.08145 6.79301C9.10445 6.67801 9.11595 6.55751 9.11595 6.43751C9.11595 6.12101 9.01794 5.88001 8.82544 5.72051C8.39394 5.36601 7.63895 5.43551 6.38294 5.86001L6.26144 5.90101L6.21144 6.53301H6.42244C7.06144 6.53301 7.21594 6.58301 7.24794 6.59851C7.29095 6.61901 7.31445 6.64351 7.31445 6.71551C7.31445 6.75551 7.30944 6.80051 7.29945 6.85051C7.28645 6.91701 7.27194 6.99401 7.25694 7.07701L6.33094 11.576C6.28794 11.8025 6.26594 11.997 6.26594 12.152C6.26594 12.5105 6.36894 12.7875 6.57144 12.9745C6.77094 13.157 7.04194 13.25 7.37944 13.25C7.77345 13.25 8.30295 13.1405 8.99695 12.916L9.12095 12.876L9.17094 12.2355H8.96044C8.48594 12.2355 8.26645 12.1895 8.16495 12.1515Z" fill="#0080FC"/>
                        <path d="M9.49553 3.02455C9.30453 2.84305 9.05953 2.75005 8.76753 2.75005C8.46503 2.75005 8.20903 2.84955 8.00753 3.04505C7.80453 3.24155 7.70103 3.50605 7.70103 3.83205C7.70103 4.13205 7.79953 4.38105 7.99303 4.57405C8.18703 4.76855 8.43453 4.86705 8.72903 4.86705C9.02853 4.86705 9.28203 4.76255 9.48453 4.55855C9.68553 4.35455 9.78753 4.08955 9.78753 3.77055C9.78753 3.45905 9.68953 3.20805 9.49553 3.02455Z" fill="#0080FC"/>
                    </svg>
                </div>
            </div>
            <div class="fs5-disclosure-card-content" >
                <div class="fs5-disclosure-left-content">
                    <div class="fs5-left-header">
                        <div class="fs5-left-header-left" >
                            <span class="fs-disclosure-title" v-html="view.content.left.title"></span>
                            <span class="fs-disclosure-subtitle" v-html="view.content.left.subtitle"></span>
                        </div>
                        <div class="fs5-left-header-right" >
                            <fs5-button 
                                v-for="(button, index) in view.content.left.buttons"
                                :key="index"
                                :label="button.label"
                                :btn-type="period == button.period ? button.btnTypeActive : button.btnType"
                                :text-transform-type="button.textTransformType"
                                @clicked="findHistory(button.period)"
                            ></fs5-button>
                        </div>
                    </div>
                    <div class="fs5-left-chart" @mouseleave="show(resume)">
                        <bar-chart
                            v-if="!loading"
                            :chartData="{
                                labels: chartData.xLabels,
                                datasets: [
                                    {
                                        label: view.content.left.chartLabel,
                                        backgroundColor: chartData.backgroundColor,
                                        data: chartData.data,
                                        barPercentage: chartData.barPercentage,
                                        categoryPercentage: 0.32
                                    }
                                ]
                            }"
                            :options="{
                                responsive: true,
                                maintainAspectRatio: false,
                                onHover: getXLabelAndSetTableData,
                                cornerRadius: 10,
                                fullCornerRadius: true, 
                                legend: {
                                    align: 'start',
                                    display: false,
                                    labels: {
                                        boxWidth: 10,
                                        fontFamily: 'Lato',
                                        fontSize: 14,
                                        fullWidth: false
                                    }
                                },
                                scales: {
                                    yAxes: [{
                                        gridLines: {
                                            borderDash: [1,2],
                                            drawBorder: false,
                                        },
                                        ticks: {
                                            min: chartOptions.min,
                                            max: chartOptions.max,
                                            stepSize: chartOptions.stepSize
                                        }
                                    }],
                                    xAxes: [{
                                        gridLines: {
                                            display: false,
                                        },
                                    }],
                                }
                            }"
                            :styles="{ // parent node
                                position: 'relative',
                                width: '100%',
                                height: 'auto',
                            }"
                            :width="534"
                            :height="300"
                            :plugins="[
                                {
                                    id: 'my-plugin',
                                    beforeInit: function (chart) {
                                        chart.legend.afterFit = function() {
                                            this.height = this.height + 30;
                                        };
                                    }
                                }
                            ]"
                        /> 
                    </div>
                </div>
                <div class="fs5-disclosure-right-content">
                    <div class="fs5-resume-header">
                        <div class="fs5-resume-url" v-html="view.content.right.labelUrl" ></div>
                        <div class="fs5-resume-clicks" v-html="view.content.right.access" ></div>
                        <div class="fs5-resume-registries" v-html="view.content.right.registration" ></div>
                    </div>
                        <div 
                            class="fs5-resume-content"
                            v-if="current.data.length"
                        >
                            <div
                                class="fs5-resume-row"
                                v-for="(row, index) in current.data"
                                :key="index"
                            >
                                <div class="fs5-resume-url" v-html="row.url" ></div>
                                <div class="fs5-resume-clicks" v-html="row.access" ></div>
                                <div class="fs5-resume-registries" v-html="row.conversions" ></div>
                            </div>
                        </div>
                        <div 
                            class="fs5-resume-empty"
                            v-else
                            v-html="view.content.right.disclosureEmpty"
                        ></div>
                </div>
            </div>
        </div>
        <div class="fs5-disclosure-buttons-row" >
            <fs5-button 
                v-for="(button, index) in this.view.buttons"
                :key="index"
                :label="button.label"
                :btn-type="button.btnType"
                :text-transform-type="button.textTransformType"
                @clicked="openTab(button.link)"
            ></fs5-button>

            <!-- <fs5-button 
                :label="`Click For Rank Definitions`"
                :btn-type="`white`"
                :text-transform-type="'capitalize'"
                @clicked=""
            ></fs5-button>
            <fs5-button 
                :label="`Compensation Plan Details`"
                :btn-type="`white`"
                :text-transform-type="'capitalize'"
                @clicked=""
            ></fs5-button> -->
        </div>

        <div class="fs5-disclosure-loader" v-show="loading" >
            <spring-spinner
                :animation-duration="2000"
                :size="50"
                color="#0080fc"
            />
        </div>
    </div>
</template>

<script>
    const BASE_URI = window.location.pathname;
    const LANGS = { us: "en", br: "pt" };

    import { SpringSpinner } from 'epic-spinners'
    import axios from "axios";

    export default {
        name: 'fs5-disclosure',
        props: ['view'],
        components: {
            'spring-spinner': SpringSpinner
        },
        data: function () {
            return {
                selectedButton: 0,

                chartOptions: {
                    min: 0,
                    max: 10,
                    stepSize: 2
                },
                chartData: {
                    xLabels: [],
                    data: [],
                    backgroundColor: '#FFDF34',
                    barPercentage: 0.666666667
                },

                //outside params
                bars: [],
                labels: [],
                current: { data: [], pie: {} },
                resume: { data: [], pie: {} },
                period: "day",
                loading: false,
                translation: this.$parent.view.translation.graphicDisclosures
            }
        },
        methods: {
            openTab(link) {
                window.open(link, '_b')
            },
            getXLabelAndSetTableData: function (event, activeElements) {

                if (activeElements.length > 0) {
                        
                        // get active chart element
                        let elt = activeElements[0];

                        // retrieve element label
                        let lbl = elt._model.label;

                        // bar hovered

                        if(lbl !== this.current.label) {
                            let res = this.bars.find(el => el.label === lbl);
                            if(res !== undefined) {
                                this.show( res )
                            }
                        }

                        
                } else {
                    // hover another place or bar empty
                    if(this.current.data.length > 0) {
                        this.show( { data: [], pie: {} } )
                    }
                }

            },
            findHistory: async function(period = this.period) {
                this.loading = true;
                this.period = period;
                try{
                    let res = await axios.get(`${BASE_URI}/disclosure/history/${period}`) // do request
                
                    // just sanitize array of data
                    let data = res.data.map(
                        v => ({
                            ...v,
                            url: v.url.replace(/https?\:\/\//, ""),
                            total: Number(v.total),
                            access: Number(v.access),
                            conversions: Number(v.conversions)
                        })
                    );

                    // history grouped by label
                    data = this.sortHistory(data);                        
                    let history = this.groupBy(data, 'label')

                    let bars = this.makeBars(period, history); // obtem somatorio dos valores das barras
                    
                    // obtem o maior valor da lista para delimitar o maximo do grafico
                    let max = bars.reduce(
                        (c, { total }) => (total > c ? total : c),
                        0
                    );
                    if (max < 10) {
                        max = 10;
                    }

                    // calcula o percentual da barra no grafico
                    let barsWithPercent = bars.map(
                        b => ({
                            bar: `calc(calc(100% - 20px) * ${max &&
                                b.total / max})`, // tamanho da barra em %
                            pie: {
                                access: `${b.total &&
                                    (b.access / b.total) * 100}%`,
                                conversions: `${b.total &&
                                    (b.conversions / b.total) * 100}%`
                            }, // percentual no grafico de pizza
                            ...b
                        })
                    );

                    // calculando labels do eixo y do grafico
                    let tick = 5;
                    let unit = max / tick;
                    let labels = [];
                    for (let i = 0; i <= tick; i++) {
                        labels.unshift(Math.floor(i * unit));
                    }

                    // history grouped by url
                    let historyByUrl = this.groupBy(data, 'url');

                    // totaliza as ocorrencias por url
                    let urls = this.sortHistory(
                        this.objMap(
                            historyByUrl,
                            s =>
                                s.reduce(
                                    (c, v) => ({
                                        url: v.url,
                                        total: c.total + v.total,
                                        access: c.access + v.access,
                                        conversions: c.conversions + v.conversions
                                    }),
                                    { total: 0, access: 0, conversions: 0 }
                                )
                        )
                    );

                    // faz o somatorio geral das urls
                    let total = urls.reduce(
                        (c, v) => ({
                            total: c.total + v.total,
                            access: c.access + v.access,
                            conversions: c.conversions + v.conversions
                        }),
                        { total: 0, access: 0, conversions: 0 }
                    );

                    // calcula resumo (barra mostrada no hover)
                    let resume = {
                        data: urls,
                        pie: { // calcula percentual no grafico de pizza
                            access: `${total.total &&
                                (total.access / total.total) * 100}%`,
                            conversions: `${total.total &&
                                (total.conversions / total.total) * 100}%`
                        }
                    };

                    // change y axis
                    this.$set(this.chartOptions, 'max', max);
                    this.$set(this.chartOptions, 'stepSize', unit);

                        
                    // change x axis
                    let xLabels = bars.map(obj => obj.label)
                    this.$set(this.chartData, 'xLabels', xLabels);

                    // set bar color
                    if(period == 'day') {
                        this.chartData.backgroundColor = '#FFDF34'
                        this.chartData.barPercentage = 0.666666667
                    } else if(period == 'month') {
                        this.chartData.backgroundColor = '#1665d8'
                        this.chartData.barPercentage = 0.666666667
                    } else {
                        this.chartData.backgroundColor = '#F24988'
                        this.chartData.barPercentage = 0.28
                    }

                    // fill bars
                    this.$set(this.chartData, 'data', bars.map(obj => obj.total))
                                            

                    this.bars = barsWithPercent;
                    this.labels = labels;
                    this.resume = resume;
                    this.show();
                } catch (e) {
                    console.log('error = ', e)
                } finally {
                    this.loading = false
                }
            },
            sortHistory(list) {
                let values = [];
                values = Array.isArray(list) ? list : Object.values(list);

                return values.sort((a, b) => {
                    if (a.conversions > b.conversions) return -1;
                    if (a.conversions < b.conversions) return 1;
                    if (a.access > b.access) return -1;
                    if (a.access < b.access) return 1;
                    return 0;
                });
            },
            makeBars(period, data) {
                // obtem somatorio dos valores das barras
                let count,
                    name,
                    format,
                    find,
                    fix = 0;
                switch (period) {
                    case "day":
                        count = 24;
                        name = "hour";
                        format = "HH";
                        find = "DD-HH";
                        fix = -1;
                        break;

                    case "month":
                        count = 30;
                        name = "day";
                        format = "DD";
                        find = "MM-DD";
                        fix = -1;
                        break;

                    default:
                        count = 12;
                        name = "month";
                        format = "MMM";
                        find = "YYYY-MM";
                        fix = -1;
                        break;
                }
                return Array.apply(null, Array(count)).map((v, i) => {
                    const month = count - i;
                    let label = moment().subtract(month + fix, name);
                    let h = data[label.format(find)] || [];

                    // faz somatorio do array de itens do periodo
                    let value = h.reduce(
                        (c, v) => ({
                            total: c.total + v.total,
                            access: c.access + v.access,
                            conversions: c.conversions + v.conversions
                        }),
                        { total: 0, access: 0, conversions: 0 }
                    );

                    return {
                        label: label.format(format),
                        ...value,
                        data: h
                    };
                });
            },
            groupBy(arr, groupByKey) {
                let obj = {};

                for(let key in arr) {
                    if( obj[ arr[key][groupByKey] ] === undefined ) {
                        obj[ arr[key][groupByKey] ] = [];
                    } 
                    obj[ arr[key][ groupByKey ] ].push(arr[key])
                }

                return obj;
            },
            objMap(obj, callback) {
                let local = [];

                for(let key in obj) {
                    local.push( callback(obj[key]) );
                }

                return local
            },
            show(v = this.resume ) {
                this.$set(this.$data, 'current', JSON.parse(JSON.stringify(v)) );
            }
        },
        mounted() {
            let locale = window.__env.locale;
            moment.locale(LANGS[locale] || locale);
            this.findHistory();
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-disclosure{
        font: inherit;
        position: relative;
        transition: 0.4s all;
        overflow: hidden;
        .fs5-disclosure-loader{
            font: inherit;
            position: absolute;
            top: 5.3em;
            left: 0;
            width: 100%;
            height: calc(100% - 5.3em);
            background-color: $fs5-color2;

            background-color: $fs5-color2;
            border-radius: 0.8em;

            display: flex;
            justify-content: center;
            align-items: center;

            opacity: 0.95;

            transition: 0.4s all;
        }
        .fs5-disclosure-card{
            font: inherit;
            border: 1px $fs5-color1 solid;
            border-radius: 0.8em;
            background-color: $fs5-color2;
            
            .fs5-disclosure-card-header{
                font: inherit;

                border-radius: 0.8em 0.8em 0 0;
                background-color: $fs5-color3;
                padding: 1em 0 1.4em 0;

                display: flex;
                align-items: center;
                justify-content: center;

                span{
                    font: inherit;
                    font-size: 2.4em;
                    line-height: 1.2;
                    font-weight: 700;
                    text-align: center;
                    text-transform: capitalize;
                    color: $fs5-color2;
                }
                .fs5-tooltip-icon{
                    font: inherit;
                    display: inline-block;
                    margin-left: 1.8em;
                    .icon{
                        font: inherit;
                        width: 1.6em;
                        height: auto;
                    }
                    &:hover{
                        cursor: pointer;
                    }
                }
            }
            .fs5-disclosure-card-content{
                font: inherit;
                display: grid;
                grid-template-columns: 59.8967298% auto;
                grid-template-rows: auto;
                .fs5-disclosure-left-content{
                    font: inherit;
                    border-right: 1px $fs5-color1 solid;
                    padding: 2.8em 2.8em 3.6em 3.2em;
                    .fs5-left-header{
                        font: inherit;
                        display: grid;
                        grid-template-columns: 34.384858% auto;
                        grid-template-rows: auto;
                        justify-content: stretch;
                        align-items: flex-end;
                        column-gap: 0.5em;
                        margin-bottom: 4em;


                        .fs5-left-header-left{
                            font: inherit;
                            display: flex;
                            flex-direction: column;

                            .fs-disclosure-title{
                                font: inherit;
                                font-size: 2em;
                                font-weight: 700;
                                line-height: 1.2;
                                color: $fs5-color19;
                                text-align: left;
                                text-transform: uppercase;
                                margin-bottom: 0.25em;

                                word-break: break-all;
                                word-wrap: break-word;
                            }
                            .fs-disclosure-subtitle{
                                font: inherit;
                                font-size: 1.4em;
                                font-weight: 700;
                                line-height: 1.2;
                                text-align: left;
                                text-transform: capitalize;
                                color: $fs5-color5;

                                word-break: break-all;
                                word-wrap: break-word;
                            }
                        }
                        .fs5-left-header-right{
                            font: inherit;
                            display: grid;
                            grid-template-columns: auto auto auto;
                            grid-template-rows: auto;
                            justify-content: stretch;
                            align-items: center;
                            column-gap: 1.4em;
                            .fs5-btn{
                                font-size: 0.75rem!important;
                                padding-top: 0.833333em!important;
                                padding-bottom: 0.833333em!important;
                            }
                        }
                    }

                    .fs5-left-chart{
                        font: inherit;
                        min-height: 30em;
                    }
                }
                .fs5-disclosure-right-content{
                    font: inherit;
                    padding: 3.6em 2.5em 3.4em 2.8em;
                    min-height: 44.9em;
                    max-height: 44.9em;
                    overflow: hidden;
                    .fs5-resume-header{
                        font: inherit;
                        display: grid;
                        grid-template-columns: 52% 1fr 1fr;
                        grid-template-rows: auto;
                        column-gap: 5px;
                        padding-bottom: 1.9em;
                        border-bottom: 1px $fs5-color3 solid;
                        margin-bottom: 2.7em;
                        .fs5-resume-url{
                            font: inherit;
                            font-size: 1.4em;
                            font-weight: 900;
                            line-height: 1.2;
                            text-align: left;
                            text-transform: capitalize;
                            color: $fs5-color19;
                        }
                        .fs5-resume-clicks{
                            font: inherit;
                            font-size: 1.4em;
                            font-weight: 900;
                            line-height: 1.2;
                            text-align: left;
                            text-transform: capitalize;
                            color: $fs5-color-21;
                        }
                        .fs5-resume-registries{
                            font: inherit;
                            font-size: 1.4em;
                            font-weight: 900;
                            line-height: 1.2;
                            text-align: left;
                            text-transform: capitalize;
                            color: $fs5-color-22;
                        }
                    }

                    .fs5-resume-content{
                        font: inherit;
                        display: flex;
                        flex-direction: column;
                        row-gap: 2.2em;

                        min-height: 30em;
                        max-height: 30em;
                        overflow-y: scroll;

                        transition: 0.4s all;
                        .fs5-resume-row{
                            font: inherit;
                            display: grid;
                            grid-template-columns: 52% 1fr 1fr;
                            grid-template-rows: auto;
                            column-gap: 5px;
                            .fs5-resume-url{
                                font: inherit;
                                font-size: 1.4em;
                                font-weight: 400;
                                line-height: 1.2;
                                text-align: left;
                                color: $fs5-color19;
                            }
                            .fs5-resume-clicks{
                                font: inherit;
                                font-size: 1.4em;
                                font-weight: 400;
                                line-height: 1.2;
                                text-align: left;
                                color: $fs5-color-21;
                            }
                            .fs5-resume-registries{
                                font: inherit;
                                font-size: 1.4em;
                                font-weight: 400;
                                line-height: 1.2;
                                text-align: left;
                                color: $fs5-color-22;
                            }
                        }
                    }

                    .fs5-resume-empty {
                        font: inherit;
                        font-size: 1.6em;
                        line-height: 1.2;
                        text-align: center;
                        color: $fs5-color23;

                        transition: 0.4s all;

                        max-height: 30em;
                        overflow-y: scroll;
                    }
                }
            }
        }
        .fs5-disclosure-buttons-row{
            font: inherit;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: auto;
            justify-content: stretch;
            align-items: center;
            column-gap: 1.8em;
            row-gap: 1.8em;
            margin-top: 1.8em;

        }
    }

    @media screen and (max-width: 1366px) {
        .fs5-disclosure{
            .fs5-disclosure-card{
                .fs5-disclosure-card-content{
                    .fs5-disclosure-left-content{
                        .fs5-left-header{
                            grid-template-columns: 1fr 1fr;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1200px) {
        .fs5-disclosure{
            .fs5-disclosure-card{
                .fs5-disclosure-card-content{
                    grid-template-columns: 1fr;
                    .fs5-disclosure-left-content{
                        border-right: none;
                        .fs5-left-header{
                            grid-template-columns: 1fr;
                            row-gap: 2em;
                            .fs5-left-header-left{
                                .fs-disclosure-title,
                                .fs-disclosure-subtitle{
                                    text-align: center;
                                }
                            }
                        }
                    }
                    .fs5-disclosure-right-content{
                        .fs5-resume-header{
                            grid-template-columns: 45% 1fr 1fr;
                        }
                        .fs5-resume-content{
                            .fs5-resume-row{
                                grid-template-columns: 45% 1fr 1fr;
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 968px) {
        .fs5-disclosure{
            .fs5-disclosure-card{
                .fs5-disclosure-card-content{
                    display: flex;
                    flex-direction: column;
                    .fs5-disclosure-left-content{
                        .fs5-left-header{
                            .fs5-left-header-right{
                                grid-template-columns: 1fr;
                                row-gap: 1em;
                            }
                        }
                    }
                    .fs5-disclosure-right-content{
                        .fs5-resume-header{
                            grid-template-columns: 45% 1fr 1fr;
                        }
                        .fs5-resume-content{
                            .fs5-resume-row{
                                grid-template-columns: 45% 1fr 1fr;
                            }
                        }
                    }
                }
            }
            .fs5-disclosure-buttons-row{
                grid-template-columns: 1fr;
                row-gap: 1em;
            }
        }
    }
</style>
<style lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-disclosure{
        .fs5-disclosure-card{
            .fs5-disclosure-card-header{
                .fs5-tooltip-icon{
                    .tooltip{
                        .tooltip-inner{
                            font-family: $fs5-font2!important;
                            font-size: 14px;
                            padding: 10px!important;
                            border-radius: 4px!important;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/disclosure/index.vue